import { useState } from 'react';
import { ArenaMedia, ma } from './ArenaMedia.jsx';
import { IconSword } from '../../components/icons.jsx';
import { ArenaModifierIcon } from './ArenaModifierIcon.jsx';

// Each card keeps the intrinsic proportions of its poster, including landscape art.
export function ArenaBattleCard({ card, as: Element = 'button', style, children, initialRatio = 0.62, ...props }) {
  const [ratio, setRatio] = useState(initialRatio);
  return <Element {...props} style={{ ...style, '--battle-art-ratio': ratio }}>
    <ArenaMedia card={card} onAspectRatio={setRatio} />
    {children}
    <span className="battle-card-power"><IconSword />{ma(card.damage)}<ArenaModifierIcon modifier={card.modifier} /></span>
  </Element>;
}
